export default __webpack_public_path__ + "static/media/640_store05-es-mobile.2eeac1e0.png";